export default {
  mainApps: {
    shenyue: {
      themeColor: '#1890ff',
      baseURL: 'https://testplatform-api.jilingshu.com.cn',
      apiPrefix: '/backend/resource'
    },
    teacherPlatform: {
      themeColor: '#1ec38f',
      // baseURL: 'http://testresource.jilingshu.com.cn',
      baseURL: 'https://testuser-api.jilingshu.com.cn/',
      // apiPrefix: ''
      apiPrefix: '/teacher/resource'
    },
    schoolPlatform: {
      themeColor: '#1ec38f',
      baseURL: 'https://testuser-api.jilingshu.com.cn/',
      apiPrefix: '/teacher/resource'
    },
    institutionPlatform: {
      themeColor: '#1890ff',
      baseURL: 'https://testresource-center.jilingshu.com.cn',
      apiPrefix: ''
    },
    // 通用服务接口调用相关配置
    commonService: {
      baseURL: 'https://testgateway.jilingshu.com.cn',
      apiPrefix: '/api/common-service'
    },
    questionsBank: {
      baseURL: 'https://testexam-center-service.jilingshu.com.cn',
      apiPrefix: ''
    }
  },
  serverURL: 'https://testresource.jilingshu.com.cn',
  pptist: {
    name: 'pptist',
    entry: 'https://testppt.jilingshu.com.cn'
    // entry: 'http://192.168.74.175:8090/'
    // entry: 'http://localhost:8090'
  },
  knowledgePoint: {
    name: 'knowledgePoint',
    entry: 'https://testppt.jilingshu.com.cn'
    // entry: 'http://192.168.74.175:8090/'
  },
  musicScore: 'https://testmusic-score.jilingshu.com.cn'
}
